import { useI18n } from "src/utils/lni18n";
import { CoursePartEditResponseModel } from "../domain/CoursePartEditResponseModel";
import UsedBy from "../Publish/UsedBy";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteConfirmDialog = (props: {
    part: CoursePartEditResponseModel,
    onSubmit: (s: boolean) => void,
    onClose: () => void;
}) => {
    const { languageService: t } = useI18n();

    return (
        <>
            <span className="moveable" data-dialog-draggable>
                <ModalHeader>{t.getText("delete")}</ModalHeader>
            </span>
            <ModalBody>
                <div className="preserve-white" >{t.getText("sure_to_delete")}</div>
                {props.part.PublishData 
                   && (props.part.PublishData.Classes?.length > 0
                   || props.part.PublishData.OtherCourses?.length > 0)
                   && <div className="mt-3">
                    <div className="mb-3 d-flex justify-content-end">
                        <button type="button" className="btn btn-primary mr-3" onClick={() => props.onSubmit(true)}>{t.getText("yes")}</button>
                        <button type="button" className="btn btn-inverse" onClick={() => props.onClose()}>{t.getText("no")}</button>
                    </div>

                    <UsedBy publishData={props.part.PublishData} />
                </div>}
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-primary mr-3" onClick={() => props.onSubmit(true)}>{t.getText("yes")}</button>
                <button type="button" className="btn btn-inverse" onClick={() => props.onClose()}>{t.getText("no")}</button>
            </ModalFooter>
        </>
    )
}

export default DeleteConfirmDialog;
